import { useGetTranslations } from '~/composables/useGetTranslations';
export default defineComponent({
  name: 'BlockSummaryNav',
  components: {},
  props: {
    summary: {
      type: Array,
      default: null
    }
  },
  setup: function setup(props) {
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var scrollToAnchor = function scrollToAnchor(hash) {
      var anchor = document.querySelector("#".concat(hash));
      if (!anchor) return;
      var y = anchor.getBoundingClientRect().top + window.scrollY;
      window.scroll({
        top: y - 10,
        behavior: 'smooth'
      });
    };
    return {
      isMobile: isMobile,
      translate: translate,
      scrollToAnchor: scrollToAnchor
    };
  }
});